import React, { FC, ReactElement, useEffect } from 'react';
import './Empty.scss';
import styled from 'styled-components';
import Set from '../../set/Set';

type emptyProps = {
    index:number|null,
    path: {
        slideIndex:number,
        comboIndex:number,
        setIndex: number|null,
        groupIndex: number|null,
        elementIndex: number|null,
    }|null,
    activePath:{
        slideIndex:number,
        comboIndex:number|null,
        setIndex: number|null,
        groupIndex: number|null,
        elementIndex: number|null,
    } | null,
    name:string,
    editorPlugins: any|null,
    settings: {
        horizontalAlignment: string,
        verticalAlignment: string
        maxWidth: string,
        setsSpace: string,
        setsPerLine:string,
    },
    sets: any,
}

type emptyComboProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
    maxWidth: string,
    setsSpace: string,
    setsPerLine: string,
}

const EmptyCombo = styled.div<emptyComboProps>`
&.emptyCombo {
  justify-content: ${props => props.horizontalAlignment || 'inherit'}; 
  align-items: ${props => props.verticalAlignment || 'inherit'};
    .set {
        display:inline-flex;
        width: ${props => ((100/Number(props.setsPerLine)).toFixed(2) || '33')}%;
        padding: 32px ${props => (props.setsSpace || '16') + 'px'};
    }
}
`;


const Empty:FC<emptyProps> = ({...props}) : ReactElement => {

    function setInstance(index: number, setData:any) {
        return <Set key={index} {...setData} editorPlugins={props.editorPlugins} index={index} path={getPath(index)} isEmptySlide={true}/>
    }

    function getPath(index:number) {
        if(props.path === null) return null;
        let path = {...props.path};
        path.setIndex = index;
        return path;
    }

    return (
        <EmptyCombo className={"combo emptyCombo"} verticalAlignment={props.settings.verticalAlignment} horizontalAlignment={props.settings.horizontalAlignment}
                    maxWidth={props.settings.maxWidth} setsSpace={props.settings.setsSpace} setsPerLine={props.settings.setsPerLine}>
            {
                props.sets.map((set: any, index: number) => {
                    return setInstance(index, set);
                })
            }
        </EmptyCombo>
    )

};
export default Empty;
